// extracted by mini-css-extract-plugin
export var deliveryRow = "_t6-a";
export var fixedHeight = "_t6-4";
export var freightLogo = "_t6-9";
export var fullWidth = "_t6-3";
export var priceColumn = "_t6-5";
export var radioSelected = "_t6-7";
export var radioUnselected = "_t6-6";
export var selectedOption = "_t6-2";
export var selectedOptionContainer = "_t6-1";
export var selection = "_t6-0";
export var tallSkeletonText = "_t6-8";